var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustrial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 0V3.97745L8.72727 5.27273V3.06836L7.63636 3.74982L5.09091 5.27273V3.06836L4 3.74982L0.363636 5.93164L0 6.136V16H16V0H10.9091ZM12.3636 1.45455H14.5455V14.5455H1.45455V6.93164L3.63636 5.63636V7.84073L4.72727 7.15927L7.27273 5.63636V7.84073L8.36364 7.15927L12 4.97745L12.3636 4.77309V1.45455ZM2.90909 8.72727V10.1818H4.36364V8.72727H2.90909ZM5.81818 8.72727V10.1818H7.27273V8.72727H5.81818ZM8.72727 8.72727V10.1818H10.1818V8.72727H8.72727ZM11.6364 8.72727V10.1818H13.0909V8.72727H11.6364ZM2.90909 11.6364V13.0909H4.36364V11.6364H2.90909ZM5.81818 11.6364V13.0909H7.27273V11.6364H5.81818ZM8.72727 11.6364V13.0909H10.1818V11.6364H8.72727ZM11.6364 11.6364V13.0909H13.0909V11.6364H11.6364Z",
    fill: "url(#paint0_linear_590_333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_590_333",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrial);
export default __webpack_public_path__ + "static/media/Industrial.f6e56a312179c597e6be73d30a04395c.svg";
export { ForwardRef as ReactComponent };